import {
    SET_COMCOURSES_LIST_NEARBY_SORT_VALUE,
    SET_COMCOURSES_LIST_SAVED_SORT_VALUE,
    SET_COMCOURSES_LIST_NEARBY_FILTER_VALUE,
    SET_COMCOURSES_LIST_SAVED_FILTER_VALUE,
    SET_COMCOURSES_LIST_NEARBY,
    SET_COMCOURSES_LIST_SAVED,
    ADD_COMCOURSE_TO_FAVORITES,
    REMOVE_COMCOURSE_FROM_FAVORITES,
    RESET_FAVORITE_COMCOURSES,
    SET_FAVORITES_NOTIFICATION_DATA,
    SET_SUGGEST_EDIT_MODAL_STATUS,
    SET_REPORT_ISSUE_MODAL_STATUS,
    SET_SUBMIT_REVIEW_MODAL_STATUS,
    SET_STAR_RATING_VALUE,
    SET_COMCOURSE_REVIEWS_SORT_VALUE,
    SET_SELECTED_COMCOURSE_REVIEW,
    SET_SUBMIT_REVIEW_PHOTOS,
    SET_CENTER_LOCATION,
    SET_SEARCHED_LOCATION,
    SET_SHARE_REVIEW_MODAL_STATUS,
    SET_SEARCH_ADDITIONAL_DATA,
    SET_ZOOM_LEVEL,
    SET_BOUNDING_BOX,
    SET_COMCOURSE_ERROR
} from '../../actions/ActionTypes.js';
import { MAP_DEFAULT_ZOOM_LEVEL } from '../../Courses/Utils.js';
import { sortTrailsList, filterTrailsList } from '../../ComCourses/Utils.js';

const INITIAL_STATE = {
    nearbyTrails: [],
    savedTrails: [],
    comCoursesListNearbySortType: null,
    comCoursesListSavedSortType: null,
    comCoursesListFilters: null,
    favoritesNotificationData: { show: false },
    comCoursesListNearbyFilters: null,
    comCoursesListSavedFilters: null,
    suggestEditModalOpened: false,
    reportIssueModalOpened: false,
    submitReviewModalOpened: false,
    starRatingValue: null,
    comCourseReviewsSortType: null,
    selectedComCourseReview: null,
    submitReviewPhotos: [],
    centerLocation: null,
    searchedLocation: null,
    shareReviewModalStatus: { show: false, tripReportId: null },
    searchAdditionalData: {},
    lastFetchedNearbyTrails: [], // used to prevent the flicker of the polylines when moving the map. We continue to show the 'old' polylines until the newly fetched ones are processed
    zoomLevel: MAP_DEFAULT_ZOOM_LEVEL,
    boundingBox: null,
    comCoursesError: null
};

const setFavoritesNotificationData = (state, action) => {
    return {
        ...state,
        favoritesNotificationData: { ...action.data }
    };
};
const setTrailsListNearby = (state, action) => {
    if (action.nearbyTrails) {
        return {
            ...state,
            nearbyTrails: action.nearbyTrails,
            lastFetchedNearbyTrails: action.nearbyTrails
        };
    }
    return {
        ...state,
        nearbyTrails: action.nearbyTrails
    };
};

const setTrailsListSaved = (state, action) => {
    return {
        ...state,
        savedTrails: action.savedTrails
    };
};

const addTrailToFavorites = (state, action) => {
    return {
        ...state,
        savedTrails: [...state.savedTrails, action.trail]
    };
};

const removeTrailsFromFavorites = (state, action) => {
    return {
        ...state,
        savedTrails: state.savedTrails.filter((trail) => trail.curatedCourseId !== action.curatedCourseId)
    };
};

const resetFavoriteTrails = (state, action) => {
    return {
        ...state,
        savedTrails: action.trails
    };
};

const setTrailsListNearbySortSuccess = (state, action) => {
    return {
        ...state,
        comCoursesListNearbySortType: action.comCoursesListNearbySortType
    };
};

const setTrailsListSavedSortSuccess = (state, action) => {
    return {
        ...state,
        comCoursesListSavedSortType: action.comCoursesListSavedSortType
    };
};

const setTrailsListNearbyFilters = (state, action) => {
    return {
        ...state,
        comCoursesListNearbyFilters: action.comCoursesListNearbyFilters
    };
};

const setTrailsListSavedFilters = (state, action) => {
    return {
        ...state,
        comCoursesListSavedFilters: action.comCoursesListSavedFilters
    };
};

const setSuggestEditModalStatus = (state, action) => {
    return {
        ...state,
        suggestEditModalOpened: action.suggestEditModalOpened
    };
};

const setReportIssueModalStatus = (state, action) => {
    return {
        ...state,
        reportIssueModalOpened: action.reportIssueModalOpened
    };
};

const setSubmitReviewModalStatus = (state, action) => {
    return {
        ...state,
        submitReviewModalOpened: action.submitReviewModalOpened
    };
};

const setStarRatingValue = (state, action) => {
    return {
        ...state,
        starRatingValue: action.starRatingValue
    };
};

const setTrailReviewsSortSuccess = (state, action) => {
    return {
        ...state,
        comCourseReviewsSortType: action.comCourseReviewsSortType
    };
};

const setSelectedTrailReview = (state, action) => {
    return {
        ...state,
        selectedComCourseReview: action.selectedComCourseReview
    };
};
const setSubmitReviewPhotos = (state, action) => {
    return {
        ...state,
        submitReviewPhotos: action.submitReviewPhotos
    };
};

const setCenterLocation = (state, action) => {
    return {
        ...state,
        centerLocation: action.centerLocation
    };
};

const setSearchedLocation = (state, action) => {
    return {
        ...state,
        searchedLocation: action.searchedLocation
    };
};

const setShareReviewModalStatus = (state, action) => {
    return {
        ...state,
        shareReviewModalStatus: action.shareReviewModalStatus
    };
};

const setSearchAdditionalData = (state, action) => {
    return {
        ...state,
        searchAdditionalData: action.additionalData
    };
};
const setZoomLevel = (state, action) => {
    return {
        ...state,
        zoomLevel: action.zoomLevel
    };
};
const setBoundingBox = (state, action) => {
    return {
        ...state,
        boundingBox: action.boundingBox
    };
};

const setTrailsError = (state, action) => {
    return {
        ...state,
        comCoursesError: action.comCoursesError
    };
};

const handlers = {
    [SET_COMCOURSES_LIST_NEARBY_SORT_VALUE]: setTrailsListNearbySortSuccess,
    [SET_COMCOURSES_LIST_SAVED_SORT_VALUE]: setTrailsListSavedSortSuccess,
    [SET_COMCOURSES_LIST_NEARBY_FILTER_VALUE]: setTrailsListNearbyFilters,
    [SET_COMCOURSES_LIST_SAVED_FILTER_VALUE]: setTrailsListSavedFilters,
    [SET_COMCOURSES_LIST_NEARBY]: setTrailsListNearby,
    [SET_COMCOURSES_LIST_SAVED]: setTrailsListSaved,
    [ADD_COMCOURSE_TO_FAVORITES]: addTrailToFavorites,
    [REMOVE_COMCOURSE_FROM_FAVORITES]: removeTrailsFromFavorites,
    [RESET_FAVORITE_COMCOURSES]: resetFavoriteTrails,
    [SET_FAVORITES_NOTIFICATION_DATA]: setFavoritesNotificationData,
    [SET_SUGGEST_EDIT_MODAL_STATUS]: setSuggestEditModalStatus,
    [SET_REPORT_ISSUE_MODAL_STATUS]: setReportIssueModalStatus,
    [SET_SUBMIT_REVIEW_MODAL_STATUS]: setSubmitReviewModalStatus,
    [SET_STAR_RATING_VALUE]: setStarRatingValue,
    [SET_COMCOURSE_REVIEWS_SORT_VALUE]: setTrailReviewsSortSuccess,
    [SET_SELECTED_COMCOURSE_REVIEW]: setSelectedTrailReview,
    [SET_SUBMIT_REVIEW_PHOTOS]: setSubmitReviewPhotos,
    [SET_CENTER_LOCATION]: setCenterLocation,
    [SET_SEARCHED_LOCATION]: setSearchedLocation,
    [SET_SHARE_REVIEW_MODAL_STATUS]: setShareReviewModalStatus,
    [SET_SEARCH_ADDITIONAL_DATA]: setSearchAdditionalData,
    [SET_ZOOM_LEVEL]: setZoomLevel,
    [SET_BOUNDING_BOX]: setBoundingBox,
    [SET_COMCOURSE_ERROR]: setTrailsError
};

export default function comCourses(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export const getTrailsListSetNearbySortType = (state) => {
    return state.comCourses.comCoursesListNearbySortType;
};

export const getTrailsListSetSavedSortType = (state) => {
    return state.comCourses.comCoursesListSavedSortType;
};

export const getTrailsListNearbyFilters = (state) => {
    return state.comCourses.comCoursesListNearbyFilters;
};

export const getTrailsListSavedFilters = (state) => {
    return state.comCourses.comCoursesListSavedFilters;
};

export const getNearbyTrails = (state) => {
    return state.comCourses.nearbyTrails?.length
        ? state.comCourses.nearbyTrails
        : state.comCourses.lastFetchedNearbyTrails;
};

export const getSavedTrails = (state) => {
    return state.comCourses.savedTrails;
};
export const getFavoritesNotificationData = (state) => {
    return state.comCourses.favoritesNotificationData;
};

export const getNearbyTrailsFilteredAndSorted = (state) => {
    let trailsList =
        state.comCourses.nearbyTrails && state.comCourses.nearbyTrails.length
            ? [...state.comCourses.nearbyTrails]
            : [...state.comCourses.lastFetchedNearbyTrails];

    if (state.comCourses.comCoursesListNearbySortType && trailsList && trailsList.length) {
        trailsList = sortTrailsList(trailsList, state.comCourses.comCoursesListNearbySortType);
    }

    if (state.comCourses.comCoursesListNearbyFilters && trailsList && trailsList.length) {
        trailsList = filterTrailsList(trailsList, state.comCourses.comCoursesListNearbyFilters);
    }

    return trailsList;
};

export const getSavedTrailsFilteredAndSorted = (state) => {
    let trailsList =
        state.comCourses.savedTrails && state.comCourses.savedTrails.length ? [...state.comCourses.savedTrails] : [];

    if (state.comCourses.comCoursesListSavedSortType && trailsList && trailsList.length) {
        trailsList = sortTrailsList(trailsList, state.comCourses.comCoursesListSavedSortType);
    }

    if (state.comCourses.comCoursesListSavedFilters && trailsList && trailsList.length) {
        trailsList = filterTrailsList(trailsList, state.comCourses.comCoursesListSavedFilters);
    }

    return trailsList;
};

export const getSuggestEditModalStatus = (state) => {
    return state.comCourses.suggestEditModalOpened;
};

export const getReportIssueModalStatus = (state) => {
    return state.comCourses.reportIssueModalOpened;
};

export const getSubmitReviewModalStatus = (state) => {
    return state.comCourses.submitReviewModalOpened;
};

export const getStarRatingValue = (state) => {
    return state.comCourses.starRatingValue;
};

export const getTrailReviewsSetSortType = (state) => {
    return state.comCourses.comCourseReviewsSortType;
};

export const getSelectedTrailReview = (state) => {
    return state.comCourses.selectedComCourseReview;
};
export const getSubmitReviewPhotos = (state) => {
    return state.comCourses.submitReviewPhotos;
};
export const getCenterLocation = (state) => {
    return state.comCourses.centerLocation;
};
export const getSearchedLocation = (state) => {
    return state.comCourses.searchedLocation;
};
export const getShareReviewModalStatus = (state) => {
    return state.comCourses.shareReviewModalStatus;
};
export const getSearchAdditionalData = (state) => {
    return state.comCourses.searchAdditionalData;
};
export const getZoomLevel = (state) => {
    return state.comCourses.zoomLevel;
};
export const getBoundingBox = (state) => {
    return state.comCourses.boundingBox;
};
export const getTrailsError = (state) => {
    return state.comCourses.comCoursesError;
};
